<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, useSlots, computed } from 'vue';

import TelaBase from '@/components/v2/base/TelaBase/TelaBase.vue';
import CartaoTabelaBase from '@/components/v2/base/CartaoTabelaBase/CartaoTabelaBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    headers: {
        type: Array,
        default: () => []
    },
    dados: {
        type: Array,
        default: () => []
    }
});

const slots = useSlots();

/*==================================================================*/
/*================== SLOTS DE ITEM =================================*/
/*==================================================================*/

const slotsDeItem = computed(() =>

    Object.keys(slots).filter(name => name.startsWith('tabela-linha-item.'))

);

const mapearSlot = (name) => name.replace('tabela-linha-item.', 'linha-item.');

</script>

<template>

    <TelaBase :disabled="props.disabled">

        <template #tela-titulo>
            <slot name="tela-titulo"></slot>
        </template>

        <CartaoTabelaBase
            :headers="props.headers"
            :dados="props.dados"
            :disabled="props.disabled"
        >

            <template #header>
                <slot name="card-header"></slot>
            </template>

            <template #linha-botoes="slotProps">
                <slot name="tabela-linha-botoes" v-bind="slotProps"></slot>
            </template>

            <template
                v-for="name in slotsDeItem"
                #[mapearSlot(name)]="slotProps"
            >

                <slot :name="name" v-bind="slotProps ?? {}"></slot>

            </template>

            <template #footer>
                <slot name="card-footer"></slot>
            </template>

        </CartaoTabelaBase>

        <slot name="modais"></slot>

    </TelaBase>

</template>

<style scoped>
</style>
